module.exports = __webpack_public_path__ + "static/img/jiaju.b65fb43.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaju.jpg
// module id = h/y6
// module chunks = 1